/* eslint-disable */
var autocomplete;
let mapLayer;
let storeContainerGeoLoc;

module.exports.init = function(mapLayer) {
  mapLayer = mapLayer;
  var inputField = cube.$('#navMap .store-selection__search-form input');
  var storeContainer = cube.$('#navMap .store-selection__result-list--autocomplete');
  storeContainerGeoLoc = cube.$('#navMap .store-selection__result-list--geoloc');
  autocomplete = new cube.woosmap.Autocomplete({
    input: inputField,
    container: cube.$('#navMap .store-selection__suggestion-list'),
    template: geolocResult =>
      `<li>${geolocResult.description}</li>`,
  });

  autocomplete.onChange = () => {
    domRemoveStoreResults(storeContainer);
    cube
      .$('#navMap .store-selection__search-form')
      .classList.add('store-selection__search-form--flushable');
  };

  autocomplete.onEmpty = flushInputValue;

  autocomplete.onSelect = geolocResult => {
    const params = {
      lat: geolocResult.geometry.location.lat(),
      lng: geolocResult.geometry.location.lng(),
      stores_by_page: 10,
    };
    cube.stores.getStores(params, stores => {
      if (stores && stores.length) {
        flushInputValue();
        removeAndDisplayStores(stores, storeContainer);
      }
    });
    showList();
    cube.$('.map-search__result-list__buttons').style.display = 'block';
  };

  $('#navMap').on('click', '.js-show-map', (e) => {
    showMap();
  });

  $('#navMap').on('click', '.js-show-list', (e) => {
    showList();
  });

  // Click locate user
  $('#navMap').on('click', '.locate-user-store', (e) => {
    getUserLocationStores(e);
    showList();
    cube.$('.map-search__result-list__buttons').style.display = 'block';
  });

  $('#navMap').on('click', '.js-show-store-page', showStorePage); 
  $('#navMap').on('click', '.js-show-gmap-dir', (e) => {
    openGoogleMapDir(e.target.dataset.destination);
  }); 

  cube
    .$('#navMap .store-selection__flush-search')
    .addEventListener('click', flushInputValue);

    mapLayer.onStoreChange = (store) => {
      if (store) {
        mapLayer.moveBy(0, -((cube.$('.gm-style-iw').parentNode.offsetHeight / 2 ) + 60 ));
        $('.woosmap-infobox__store-directions').on('click', (e) => {
          openGoogleMapDir(`${store.geometry.coordinates[1]},${store.geometry.coordinates[0]}`);
        });
        $('.woosmap-infobox__store-button').on('click', showStorePage);
      }
   };
  bindStoreActions();
};

const openGoogleMapDir = (destination) => {
  window.location.href = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
};


const showStorePage = (e) => {
  const storeId = e.target.dataset.storeId;
  cube.stores.getCountryStoresList((list) => {
    const store = list.find(s => s.storeId === storeId); 
    window.location.href = Cube.Utils.localizeUri(store.storeUrl);
  });
};

const showMap = () => {
  cube.$('.map-search__result-list').style.display = 'none';
  cube.$('.js-show-map').style.display = 'none';
  cube.$('.js-show-list').style.display = 'inline-flex';  
}

const showList = () => {
  cube.$('.map-search__result-list').style.display = 'flex';
  cube.$('.js-show-map').style.display = 'inline-flex';
  cube.$('.js-show-list').style.display = 'none';
}

const getUserLocationStores = (e) => {
  let geolocBtn = e.target;
  if (!geolocBtn.classList.contains('locate-user-store'))
    geolocBtn = geolocBtn.closest('.locate-user-store');

  const locationData = cube.stores.askLocation((data) => {
    const params = {
      lat: data.latitude,
      lng: data.longitude,
    };
    cube.stores.getStores(params, stores => {
      if (stores && stores.length) {
        removeAndDisplayStores(stores, storeContainerGeoLoc);
      }
    });
  });
};

// Clear LIST OF STORES and display a new one
const removeAndDisplayStores = (stores, storeContainer) => {
  domRemoveStoreResults(storeContainer);
  domAddResultTitle(stores.length, storeContainer);
  stores.forEach(domAddStore(storeContainer));
};

// Remove ALL STORES RESULTS (ie. list item + title) from the result list
const domRemoveStoreResults = storeContainer => {
  const containerParent = storeContainer.parentNode;
  if (containerParent.$$('.js-store-result'))
    containerParent.$$('.js-store-result').forEach(e => e.remove());
};

// Add Title on top of the result list
const domAddResultTitle = (storeCount, storeContainer) => {
  storeContainer.insertAdjacentHTML(
    'beforebegin',
    `<h3 class="store-selection__list-title js-store-result">${window.Messages('storeselection.storeListTitle', storeCount)}</h3>`
  );
};
// Add ONE STORE to the result list
const domAddStore = storeContainer => (store, storeIndex) => {
  if (!store.properties) return;
  const p = store.properties;
  storeContainer.insertAdjacentHTML(
    'beforeend',
    buildTemplate(p, storeIndex)
  );
};

const flushInputValue = () => {
  autocomplete.input.value = '';
  autocomplete.removePredictions();
  cube
    .$('#navMap .store-selection__search-form')
    .classList.remove('store-selection__search-form--flushable');
};

// Build list template
const buildTemplate = (p, storeIndex) => {
  let storeHours = '';
  if (p.open.open_now)
    storeHours = `<span class="store-selection__hours">${window.Messages('storeselection.storeOpeningHours', p.open.current_slice.start, p.open.current_slice.end)}</span>`;
  else
    storeHours = `<span class="store-selection__hours store-selection__hours--closed">${window.Messages('storeselection.storeIsClosed')}</span>`;


  let streetAddress = '';
  p.address.lines.forEach(line => {
    if (line) streetAddress += `<span>${line}</span><br>`;
  });
  streetAddress += `<span>${p.address.zipcode} ${p.address.city}</span><br>`;

  return `<dt class="store-selection__store-header js-store-result" data-store-id="${p.store_id}">
    <h4>${storeIndex + 1} - ${p.name}</h4>
    ${storeHours}
    <span class="store-distance">${Math.round(p.distance / 100) / 10}km</span>
    <span class="icon icon-arrow1-d"></span>
  </dt>
  <dd class="store-selection__store-details js-store-result">
    <p>
      ${streetAddress}
      <a href="tel:${p.contact.phone}">${p.contact.phone}</a>
    </p>
    <button class="cta-v2 cta-v2--2nd cta-v2--outline cta-v2--s js-show-store-page" data-store-id="${p.store_id}">${window.Messages('woosmap.store.seestore')}</button>
  </dd>`;
};

const bindStoreActions = () => {
  // bind lists
  cube.$('#navMap').addEventListener('click', event => {
    // handle store info toggling
    const storeClass = 'store-selection__store-header';
    const storeClassShowedClass = `${storeClass}--showed`;
    const storeSelectionCtaClass = 'js-store-selection';
    const isDt = event.target.classList.contains(storeClass);
    const isDtChild = !!event.target.closest(`.${storeClass}`);
    const isStoreSelectionCta = event.target.classList.contains(storeSelectionCtaClass);
    let targetDt = null;

    if (isDt) targetDt = event.target;
    else if (isDtChild) targetDt = event.target.closest(`.${storeClass}`);

    if (isDt || isDtChild) {
      targetDt.parentNode.$$(`.${storeClass}`).forEach(dt => {
        if (dt !== targetDt) dt.classList.remove(storeClassShowedClass);
      });
      targetDt.classList.toggle(storeClassShowedClass);
    }

    // handle store selection cta
    if (isStoreSelectionCta) {
      cube.stores
        .setDefaultStore(event.target.dataset.storeId)
        .then(storeSettingajaxSucces);
    }
  });
}


// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/nav-mobile-map.js